import React from 'react';
import { hydrate } from 'react-dom';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { ErrorLogComponent } from '@cian/error-log-component';
import {
  fetchWebGetUserFavorites,
  IWebGetUserFavoritesRequest,
  TWebGetUserFavoritesResponse,
} from '../../../shared/repositories/favorites/v1/web-get-user-favorites';

export const initializeFavorites = async (favLink: string) => {
  const favoritesPanelElement = document.getElementById('header-user-favorites');
  const logger = getLogger();

  if (favoritesPanelElement) {
    const { Favorites } = await import('../../../shared/components/Favorites');

    hydrate(
      <ErrorLogComponent logger={logger}>
        <Favorites getFavorites={getFavorites} favLink={favLink} />
      </ErrorLogComponent>,
      favoritesPanelElement,
    );
  }
};

export async function getFavorites(parameters: IWebGetUserFavoritesRequest) {
  const config = { ecnhancersConfig: { timeout: 1000 } };

  return fetchWebGetUserFavorites({ httpApi: getHttpApi(), parameters, config })
    .then((response: TWebGetUserFavoritesResponse) => {
      if (response.statusCode !== 200) {
        return null;
      }

      const {
        response: { canLoadMore, favoriteEntities, counts },
      } = response;

      return {
        canLoadMore,
        favoriteEntities,
        counts,
      };
    })
    .catch(error => {
      getLogger().error(error, {
        domain: 'fetchWebGetUserFavorites',
        details: {
          repository: 'frontend-header',
          service: 'header',
        },
      });

      throw new Error(error);
    });
}
